const binding = { modules: {}, dataActions: {} };

    (binding.modules['cws-form'] = {
        c: () => require('partner/modules/cws-form/cws-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cws-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cws-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cws-form|cws-form'] = {
                c: () => require('partner/modules/cws-form/cws-form.view.tsx'),
                cn: '__local__-__local__-cws-form'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };